// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2155) return "static/chunks/2155-afcadd1840b01e67.js";
	if (chunkId === 7955) return "static/chunks/7955-a672679502fd45ac.js";
	if (chunkId === 9533) return "static/chunks/9533-8ecdaf79ef52a841.js";
	if (chunkId === 8653) return "static/chunks/8653-820237efb34cfd40.js";
	if (chunkId === 2302) return "static/chunks/2302-24ca62ac9b192519.js";
	if (chunkId === 1272) return "static/chunks/1272-4999c4ee84d662c0.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"1460":"e24bf851","6169":"ed48eaa7"}[chunkId] || chunkId) + "." + {"243":"701b5ecf8d2cc6ed","522":"2d7e3b8dbb808932","1460":"30b1d7e1422776ef","1897":"bc5d87d625a4dc72","2871":"aff5234d618251db","3043":"5776f87baba6ce76","6169":"f998a7ea381d6082","8511":"569559eb8559973d"}[chunkId] + ".js";
};